/**
 * ヘルスチェック API リポジトリ
 */
import { adminApiFetch } from '../utils/adminApi.js';

class AdminHealthCheckRepository {
  static instance = null;

  static getInstance() {
    if (!AdminHealthCheckRepository.instance) {
      AdminHealthCheckRepository.instance = new AdminHealthCheckRepository();
    }
    return AdminHealthCheckRepository.instance;
  }

  async fetchReport() {
    return adminApiFetch('/api/admin/health-check');
  }

  async runL2Check() {
    return adminApiFetch('/api/admin/health-check/run-l2', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    });
  }

  async runL3Check() {
    return adminApiFetch('/api/admin/health-check/run-l3', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    });
  }

  /** L2 + L3 順次実行 */
  async runFullCheck() {
    return adminApiFetch('/api/admin/health-check/run', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    });
  }

  async probeTarget(probeId, level = 'l2') {
    const data = await adminApiFetch('/api/admin/health-check/probe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ probeId, level }),
    });
    return data.result;
  }
}

export default AdminHealthCheckRepository;
